import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Typography, Stack } from "@mui/material";
import { COUNTRIES, STATES, RELATIONSHIPS } from "@constants";
import { formatToPhoneNumber } from "utils/formatFormFields";
import { formatJsonDate } from "utils/dateFromJSONDate";

interface ViewRowCellProps {
  sm?: number;
  title: string;
  value?: string | number | null;
}

const ViewRowCell: React.FC<ViewRowCellProps> = ({ sm = 12, title, value }) => (
  <Grid xs={12} sm={sm}>
    <Stack gap={3}>
      <Typography variant="body2" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="body2" fontWeight={500}>
        {value || "-"}
      </Typography>
    </Stack>
  </Grid>
);

interface ViewFieldsProps {
  guarantor: any;
}

/**
 * ViewFields displays the financial guarantor information in a read-only grid layout.
 */
const ViewFields: React.FC<ViewFieldsProps> = ({ guarantor }) => {
  if (!guarantor) {
    return (
      <Typography
        component="p"
        variant="body2"
        color="textSecondary"
        sx={{ width: "100%", lineHeight: 6 }}
      >
        No Financial Guarantor on the account
      </Typography>
    );
  }

  const {
    firstName,
    lastName,
    dateOfBirth,
    gender,
    email,
    phone,
    relationshipToClient,
    country,
    state,
    city,
    zipCode,
    address1,
    address2,
  } = guarantor;

  const formattedDate = formatJsonDate(dateOfBirth);
  const formattedPhone = phone ? formatToPhoneNumber(phone) : null;

  return (
    <Grid container columnSpacing={5} rowSpacing={7} width="100%">
      <ViewRowCell sm={12} title="Guarantor's first name" value={firstName} />
      <ViewRowCell sm={12} title="Guarantor's last name" value={lastName} />
      <ViewRowCell sm={12} title="Guarantor's date of birth" value={formattedDate} />
      <ViewRowCell sm={12} title="Guarantor's gender" value={gender} />
      <ViewRowCell sm={12} title="Guarantor's email address" value={email} />
      <ViewRowCell sm={12} title="Guarantor's phone number" value={formattedPhone} />
      <ViewRowCell
        sm={12}
        title="Relationship to client"
        value={relationshipToClient ? RELATIONSHIPS[relationshipToClient as keyof typeof RELATIONSHIPS] : undefined}
      />
      <ViewRowCell sm={12} title="Country" value={country ? COUNTRIES[country as keyof typeof COUNTRIES] : undefined} />
      <ViewRowCell sm={12} title="State" value={state ? STATES[state as keyof typeof STATES] : undefined} />
      <ViewRowCell sm={12} title="City" value={city} />
      <ViewRowCell sm={12} title="ZIP code" value={zipCode} />
      <ViewRowCell sm={12} title="Guarantor's address" value={address1} />
      <ViewRowCell sm={12} title="Guarantor's address 2" value={address2} />
    </Grid>
  );
};

export default ViewFields;
